import * as React from 'react'
import { Box, Typography } from '@mui/material'


export default function numWinsColumn(label) {
    return {
        name: 'numWins', label: 'Num Of Wins',
        options: {
            customBodyRowRenderLite: (value) => <Box sx={{ textAlign: 'center' }}>
                <Typography >{value}</Typography>
            </Box>
        }
    }
}